'use client';

import { c as _c } from "react/compiler-runtime";
import RegistrationBirthdayDatePicker from '@app/registration/(with-padding)/_basic/RegistrationBirthdayDatePicker';
import RegistrationGenderPicker from '@app/registration/(with-padding)/_basic/RegistrationGenderPicker';
import css from '@app/registration/(with-padding)/_basic/SecondScreen.module.css';
import { FormikCitySelector } from '@components/CitySelector/FormikCitySelector';
import { INLink } from '@components/INLink';
import StepHeader from '@components/Registration/StepHeader';
import { Checkbox, ChevronLeftIcon, FormControl, FormControlLabel, FormHelperText, GenderPictogram, IconButton, Typography } from '@internations/ds';
import { privacyPolicy, termsAndConditions } from '@routes/catalog';
import { toURL } from '@routes/utils/toURL';
import { Field, FieldInputProps, useField, useFormikContext } from '@util/Formik';
import bornInLabel from '@util/labels/bornIn';
import livingInLabel from '@util/labels/livingIn';
import privacyPolicyLabel from '@util/labels/privacyPolicy';
import tellUsMoreAboutYouLabel from '@util/labels/tellUsMoreAboutYou';
import termsAndConditionsLabel from '@util/labels/termsAndConditions';
import { BasicFormValues, BasicRegistrationFormErrors } from '@util/registration/BasicFormModel';
import { BaseSyntheticEvent, ReactElement, useEffect } from 'react';
const PrivacyPolicyLink = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <INLink route={privacyPolicy} target="_blank" rel="noreferrer" variant="caption">{privacyPolicyLabel}</INLink>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
const TermsAndConditionsLink = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <INLink route={termsAndConditions} target="_blank" rel="noreferrer" variant="caption">{termsAndConditionsLabel}</INLink>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export const IAgreeToTermsAndConditions = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <PrivacyPolicyLink />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Typography variant="caption">{"I accept the InterNations "}{t0}{" (including the use of cookies) and the "}<TermsAndConditionsLink />{". The legal basis for the processing of your data is Art. 6 (1) (b). GDPR"}</Typography>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
const TermsAndConditionsCheckbox = props => {
  const $ = _c(5);
  let t0;
  if ($[0] !== props) {
    t0 = <Checkbox {...props} data-testid="termsAndConditionsCheckbox" />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <IAgreeToTermsAndConditions />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t0) {
    t2 = <FormControlLabel control={t0} label={t1} />;
    $[3] = t0;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
const TermsAndConditions = () => {
  const $ = _c(15);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      name: "terms",
      type: "checkbox"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [t1, t2, t3] = useField(t0);
  const {
    checked
  } = t1;
  const {
    touched,
    error
  } = t2;
  const {
    setValue
  } = t3;
  const hasError = Boolean(touched && error);
  let t4;
  if ($[1] !== setValue) {
    t4 = e => {
      setValue(e.target.checked, true);
    };
    $[1] = setValue;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const onChange = t4;
  const t5 = hasError ? error : null;
  const t6 = error ?? null;
  let t7;
  if ($[3] !== checked || $[4] !== onChange || $[5] !== t5 || $[6] !== t6) {
    t7 = <Field type="checkbox" name="terms" as={TermsAndConditionsCheckbox} error={t5} helpertext={t6} checked={checked} onChange={onChange} />;
    $[3] = checked;
    $[4] = onChange;
    $[5] = t5;
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== error || $[9] !== hasError) {
    t8 = hasError ? <FormHelperText>{error}</FormHelperText> : null;
    $[8] = error;
    $[9] = hasError;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== hasError || $[12] !== t7 || $[13] !== t8) {
    t9 = <FormControl error={hasError} className="mt-2">{t7}{t8}</FormControl>;
    $[11] = hasError;
    $[12] = t7;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  return t9;
};
type SecondScreenProps = {
  backendErrors?: BasicRegistrationFormErrors;
};
function SecondScreen(t0) {
  const $ = _c(23);
  const {
    backendErrors
  } = t0;
  const formikProps = useFormikContext();
  const {
    setFieldTouched,
    setFieldValue
  } = formikProps;
  const handleBackClick = _temp;
  let t1;
  let t2;
  if ($[0] !== setFieldTouched) {
    t1 = () => {
      setFieldTouched("gender", false);
      setFieldTouched("bornIn", false);
      setFieldTouched("livingIn", false);
      setFieldTouched("birthday", false);
      setFieldTouched("terms", false);
    };
    t2 = [setFieldTouched];
    $[0] = setFieldTouched;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="absolute mt-1"><IconButton onClick={handleBackClick} Icon={ChevronLeftIcon} aria-label="back" data-testid="backButton" /></div>;
    t4 = <StepHeader Pictogram={GenderPictogram} heading={tellUsMoreAboutYouLabel} className="mb-4.5" />;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="mb-2"><RegistrationGenderPicker /></div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const t6 = backendErrors?.bornIn;
  let t7;
  if ($[6] !== setFieldValue) {
    t7 = place => setFieldValue("bornIn", place);
    $[6] = setFieldValue;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t6 || $[9] !== t7) {
    t8 = <FormikCitySelector fieldName="bornIn" label={bornInLabel} forcedError={t6} onSelect={t7} className={css.locationField} fullWidth={true} />;
    $[8] = t6;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  const t9 = backendErrors?.livingIn;
  let t10;
  if ($[11] !== setFieldValue) {
    t10 = place_0 => setFieldValue("livingIn", place_0);
    $[11] = setFieldValue;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== t10 || $[14] !== t9) {
    t11 = <FormikCitySelector fieldName="livingIn" label={livingInLabel} forcedError={t9} onSelect={t10} className={css.locationField} fullWidth={true} />;
    $[13] = t10;
    $[14] = t9;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== t11 || $[17] !== t8) {
    t12 = <div className={css.locationFieldWrapper}>{t8}{t11}</div>;
    $[16] = t11;
    $[17] = t8;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  let t14;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <RegistrationBirthdayDatePicker />;
    t14 = <TermsAndConditions />;
    $[19] = t13;
    $[20] = t14;
  } else {
    t13 = $[19];
    t14 = $[20];
  }
  let t15;
  if ($[21] !== t12) {
    t15 = <>{t3}{t4}<div>{t5}{t12}{t13}{t14}</div></>;
    $[21] = t12;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  return t15;
}
function _temp() {
  const url = toURL(window.location.href);
  url.searchParams.set("step", "first");
  window.history.replaceState(null, "", url.toString());
}
export default SecondScreen;